import moment from 'utils/cops-moment';
import { viewConfig } from '../config';
import { viewIds } from '../config/view';

const determineDayOffset = (view, day) => view?.parameters?.workingDays?.indexOf(day);

const calculateCurrentTimeIndicator = (
  currentTime,
  dateReference,
  viewDimensions,
  ganttDimensions,
  view,
) => {
  const day = currentTime.day();
  const hour = currentTime.hours();

  const { calendarType } = view;
  // day month --> should start from a specific date
  let dateToStartFrom = moment()
    .year(dateReference.year)
    .month(dateReference.month)
    .date(dateReference.day)
    .hours(viewDimensions.startHour)
    .minutes(0)
    .seconds(0);

  // week --> should start from the starting of the week
  if (calendarType === 'week') {
    dateToStartFrom = moment()
      .year(dateReference.year)
      .month(dateReference.month)
      .date(dateReference.day)
      .startOf('week')
      .hours(viewDimensions.startHour)
      .minutes(0)
      .seconds(0);
  }

  let twoWorkWeekOffset = 0;
  if (view.id === viewIds.twoWorkWeeks && currentTime.date() > dateToStartFrom.date() + 4) {
    dateToStartFrom =
      dateToStartFrom.add(currentTime.date() > dateToStartFrom.date() + 4 ? 1 : 0, 'week');
    twoWorkWeekOffset = 5;
  }
  const dateToStartFromToNow = currentTime.diff(dateToStartFrom, 'minutes');
  const startWidthOffset = viewConfig.indicatorOffset;
  const dayOffset = determineDayOffset(view, day);
  const totalDayBreakerWidth =
    `(${dayOffset + twoWorkWeekOffset}) * ${view?.parameters?.widthDayBreaker}px`;
  const noneWorkingMinutes =
    // eslint-disable-next-line
    (dayOffset) * (24 - viewDimensions.endHour + viewDimensions.startHour) * 60;
  let minutesOffset =
    ganttDimensions.widthDimension * (dateToStartFromToNow - noneWorkingMinutes);
  if (twoWorkWeekOffset) {
    minutesOffset += 5 * 9 * 60 * ganttDimensions.widthDimension;
  }
  if (hour >= viewDimensions.startHour && hour < viewDimensions.endHour) {
    return `calc(${minutesOffset}% + ${startWidthOffset} + ${totalDayBreakerWidth})`;
  } else if (hour < viewDimensions.startHour) {
    if (dayOffset === 0) {
      return startWidthOffset;
    }
    // eslint-disable-next-line
    return `calc(${ganttDimensions.widthDay *
      // eslint-disable-next-line max-len
      dayOffset}% + ${startWidthOffset} + ${totalDayBreakerWidth} - ${view?.parameters?.widthDayBreaker / 2}px)`;
  } else if (hour >= viewDimensions.endHour) {
    // eslint-disable-next-line
    return `calc(${ganttDimensions.widthDay * (dayOffset + 1 + twoWorkWeekOffset)}% + ${startWidthOffset} + ${totalDayBreakerWidth} + ${view?.parameters?.widthDayBreaker / 2}px)`;
  }
  return startWidthOffset;
};

export default calculateCurrentTimeIndicator;
